import gql from 'graphql-tag';

export default gql`
  mutation orderUpdatePoNumber($input: OrderUpdatePoNumberInput!) {
    orderUpdatePoNumber(input: $input) {
      success
      order {
        poNumber
      }
    }
  }
`;
